















































import Card from "@/components/layout/card.vue";
import UserSelector from "@/components/pickers/user-selector.vue";
import { userService } from "@/services/user";
import { User } from "@/swagger/models";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "BookingAllowanceUser",
})
export default class BookingAllowanceUser extends Vue {
    @Prop({ required: true })
    user: User;

    @Prop({ default: 0 })
    defaultValue: number;

    value: string | number | null = null;

    unrestricted: boolean = false;

    dirty: boolean = false;

    @Watch("user", { immediate: true })
    init() {
        // @ts-ignore (maxReservations is object in swagger model)
        this.unrestricted = this.user.maxReservations >= 100;
        // @ts-ignore (maxReservations is object in swagger model)
        this.value = this.unrestricted ? this.defaultValue : this.user.maxReservations;
    }

    @Watch("value")
    @Watch("unrestricted")
    setDirty() {
        this.dirty = true;
    }

    emitValue() {
        if ((this.value === null || this.value === "") && !this.unrestricted) {
            this.$tosti.warning({ message: "Please enter a value or tick the unrestricted checkbox" });
            return;
        }
        this.$emit("update", this.unrestricted ? 100 : this.value);
        this.dirty = false;
    }
}
